module.exports = __webpack_public_path__ + "img/puzzle.be5030ca.webp";